import { Component, OnInit } from '@angular/core';
import { AppService, IMessage } from '../app.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  providers: [AppService]
})
export class ContactComponent implements OnInit {

  message: IMessage = {};

  constructor(private appService: AppService) { }


  sendEmail(message:IMessage){
    this.appService.sendEmail(message).subscribe(res => {
    }, error => {
      console.log('ContactComponent Error', error);
    });
  }

  ngOnInit() {

    function Toggle(){
      var faq = document.querySelectorAll('.faq-box');
      for(var i = 0 ; i < faq.length ; i++ ){
        faq[i].addEventListener('click',function(){
          this.classList.toggle('active');
        })
      }
    }

    Toggle();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/corpo-leve-www/www/src/app/contact/contact.component.ts